import { render, staticRenderFns } from "./More.vue?vue&type=template&id=991eaf2e&scoped=true"
var script = {}
import style0 from "./More.vue?vue&type=style&index=0&id=991eaf2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991eaf2e",
  null
  
)

export default component.exports